import { hidePopup } from '@/components/PopupContainer/popupService';
import { useCallback } from 'react';
import { INVITE_FLOW_STEP, useInviteFlow } from '../viewmodels/useInviteFlow';
import { EmailInviteModal } from './EmailInviteModal';
import { InviteOptionsDrawer } from './InviteOptionsDrawer';
import { ShareLinkModal } from './ShareLinkModal';
import './inviteFlow.scss';

export const INVITE_FLOW_POPUP_ID = 'invite_flow_modal';

const InviteFlowModal = () => {
   const closeInviteFlow = useCallback(() => {
      hidePopup(INVITE_FLOW_POPUP_ID);
   }, []);

   const { currentStep, stepViewModels } = useInviteFlow(closeInviteFlow);

   const componentByStep = {
      [INVITE_FLOW_STEP.SHARE]: ShareLinkModal,
      [INVITE_FLOW_STEP.EMAIL]: EmailInviteModal,
      [INVITE_FLOW_STEP.OPTIONS]: InviteOptionsDrawer,
   };

   const ActiveStepComponent = componentByStep[currentStep] ?? InviteOptionsDrawer;
   const activeStepViewModel = stepViewModels[currentStep] ?? stepViewModels[INVITE_FLOW_STEP.OPTIONS];

   return <ActiveStepComponent viewModel={activeStepViewModel} />;
};

export default InviteFlowModal;
